import gql from 'graphql-tag'

export const BASE_DATA = gql`
  query {
    allSurveys(order: "created_at DESC", where: { status: "live" }) {
      id
      name
      importStatus: i18nStatus
      createdAt: i18nDate
      official: i18nOfficial
    }
  }
`

export const IMPORT_SURVEY = gql`
  mutation ImportSurvey($file: Upload!, $surveyName: String!) {
    importSurvey(file: $file, surveyName: $surveyName)
  }
`
